module.exports = __webpack_public_path__ + "img/logo_fottorama_grey.47fffe26.png";